import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import 'hooper/dist/hooper.css';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let BpiIntegration = class BpiIntegration extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin, UserAgentMixin) {
    get demoBanners() {
        return [
            'bpi-demo-1.png',
            'bpi-demo-2.png',
            'bpi-demo-3.png',
            'bpi-demo-4.png',
            'bpi-demo-5.png',
        ].map((img) => `${S3_ASSETS_BUCKET_URL}/${img}`);
    }
    get benefits() {
        return [
            {
                title: 'Guaranteed checkout sessions',
                description: `The customer will have to place the order first before proceeding with the 
                      actual payment process. This implementation will make sure that the transaction 
                      is already created in case there’s an issue with redirecting to BPI’s online payment 
                      facility.`,
                img: {
                    src: `${S3_ASSETS_BUCKET_URL}/bpi-benefit-1.png`,
                    height: this.mdAndUp ? 630 : 420,
                },
            },
            {
                title: 'Two-factor authentication',
                description: `To confirm the payment, customers have to provide their username and password 
                      on the BPI login page. For added security, BPI requires OTP that will be sent 
                      to customer’s mobile number.`,
                img: {
                    src: `${S3_ASSETS_BUCKET_URL}/bpi-benefit-2.png`,
                    height: this.mdAndUp ? 661 : 420,
                },
            },
            {
                title: 'No more screenshot requirement for BPI account holders',
                description: `The BPI Online payment process is completely automated. No more 
                      taking screenshot of the proof of deposit.`,
                img: {
                    src: `${S3_ASSETS_BUCKET_URL}/bpi-benefit-3.png`,
                    height: this.mdAndUp ? 690 : 420,
                },
            },
        ];
    }
    get processingFeeHeaders() {
        return ['Online Payment Partner', 'Requirement', 'Online Payment Fee', 'Activation Fee'];
    }
    get processingFeeTableContents() {
        return [
            'BPI Online',
            'Business documents for Know Your Merchant Compliance',
            '₱25 (₱15 goes to BPI and ₱10 goes to ChatGenie)',
            'FREE using ChatGenie’s MID / ₱5,000 if Merchant has their own MID',
        ];
    }
    get videoDimensions() {
        if (this.smAndDown) {
            return { width: 320, height: 250 };
        }
        return { width: 820, height: 520 };
    }
    openLink($event) {
        window.open($event.target.outerText);
    }
    mounted() {
        this.segmentTrack('Chatgenie Website Visit');
    }
};
BpiIntegration = __decorate([
    Component({
        components: {
            Hooper,
            Slide,
            HooperPagination,
            TheFooter,
            GetStarted,
        },
    })
], BpiIntegration);
export default BpiIntegration;
